import React, { useState } from 'react';
import styles from './FormLeads.module.scss';
import Header from 'component/layout/header/Header';
import TableComponent from 'component/molecules/Table/TableComponent';
import Button from 'component/atom/forms/button/Button';
import { useNavigate, useParams } from 'react-router-dom';
import { formsEndpoints } from 'hooks/endpoints';
import { useFetch } from 'hooks/useFetch';
import { API_URL } from 'constants';
import { securityHeaders } from 'helpers/headers';

const FormLeads = () => {
  const { formId, categoryId } = useParams();
  const navigate = useNavigate();
  const [isPendingPdf, setIsPendingPdf] = useState(false);
  const [isPendingXls, setIsPendingXls] = useState(false);

  const { data: formResponseData } = useFetch(
    ['formResponseData', formId],
    formsEndpoints?.getFormResponsesAsCategories,
    { enabled: true },
    { FormId: formId, CategoryId: categoryId }
  );

  const downloadFile = async (url, filename) => {
    const res = await fetch(API_URL + url, {
      method: 'GET',
      headers: {
        ...securityHeaders(),
        Accept: '*/*',
      },
    });
    const blob = await res.blob();
    const fileUrl = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = fileUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(fileUrl);
  };

  const handleDownloadXls = async () => {
    setIsPendingXls(true);
    try {
      await downloadFile(
        `/Forms/ExportFormEntriesFromBotAndCategory/${formId}/${categoryId}`,
        `form-${formId}-${categoryId}.xlsx`
      );
    } catch (err) {
      console.error('Download failed', err);
    } finally {
      setIsPendingXls(false);
    }
  };

  const handleDownloadPdf = async () => {
    setIsPendingPdf(true);
    try {
      await downloadFile(
        `/Forms/ExportFormEntriesFromBotAndCategoryPdf/${formId}/${categoryId}`,
        `form-${formId}-${categoryId}.pdf`
      );
    } catch (err) {
      console.error('PDF download failed', err);
    } finally {
      setIsPendingPdf(false);
    }
  };

  const filterButtons = [
    {
      label: 'PDF',
      opicBackground: true,
      func: handleDownloadPdf,
      type: 'download',
      isLoading: isPendingPdf,
    },
    {
      label: 'XLS',
      opicBackground: true,
      func: handleDownloadXls,
      type: 'download',
      isLoading: isPendingXls,
    },
  ];

  const renderDetailsButton = (item) => {
    return (
      <Button
        label='View Profile'
        onClick={(e) => {
          e.stopPropagation();
          navigate(`/bot/contact-profile/${formId}/${item?.item?.chatId}`);
        }}
        variant='#0744E1'
        className={styles['view-details-btn']}
      />
    );
  };

  return (
    <div>
      <Header
        title={formResponseData?.data?.category?.categoryText}
        tag={
          (formResponseData?.data?.totalCount ?? 0) +
          ' ' +
          ((formResponseData?.data?.totalCount ?? 0) === 1 ? 'lead' : 'leads')
        }
        isBack
        isSub
      />
      <TableComponent
        rowKey='id'
        headerData={{
          tableName: 'Data',
          hasExport: false,
          hasSearch: true,
          hasDelete: false,
          hasEdit: false,
          hasPaging: true,
          hasCheckbox: false,
          hasUploadCSV: false,
          hasFilter: false,
          hasInternalSearch: true,
          actionTitle: 'Actions',
          fields: [
            ...(formResponseData?.data?.headers?.formDetails?.map((item) => ({
              fieldName: item.fieldLabel,
              headerName: item.fieldLabel,
            })) || []),
            {
              fieldName: 'createdOn',
              headerName: 'Date',
              isDatetime: true,
            },
          ],
        }}
        filterButtons={filterButtons}
        renderAdditionalComponent={renderDetailsButton}
        isFormResponse
        hasAction={true}
        hasFileModal={true}
        api={{
          get: {
            url: formsEndpoints?.getFormResponsesAsCategories,
            queryKey: 'forms',
            params: {
              FormId: formId,
              CategoryId: categoryId,
            },
            enabled: !!formId,
          },
        }}
      />
    </div>
  );
};

export default FormLeads;
